(function() {
  var strip = document.getElementById('hm-gallery-strip');
  if (!strip) return;
  var appMain = document.querySelector('.h-app__main');
  var gallery = document.getElementById('hm-gallery');
  if (!appMain || !gallery) return;

  // Create mobile close button for the gallery overlay
  var mobileCloseBtn = document.createElement('button');
  mobileCloseBtn.className = 'hm-gallery-mobile-close';
  mobileCloseBtn.type = 'button';
  mobileCloseBtn.innerHTML = '\u2715';
  mobileCloseBtn.title = 'Close gallery';
  gallery.appendChild(mobileCloseBtn);

  // Create fixed-height wrapper + image BEFORE gallery (so image appears above thumbs)
  var galleryWrap = document.createElement('div');
  galleryWrap.className = 'hm-gallery-full-wrap';
  var galleryImg = document.createElement('img');
  galleryImg.className = 'hm-gallery-full';
  galleryImg.alt = 'Product photo';
  galleryWrap.appendChild(galleryImg);

  // Video element (hidden by default)
  var galleryVideo = document.createElement('video');
  galleryVideo.className = 'hm-gallery-full hm-gallery-full--video';
  galleryVideo.controls = true;
  galleryVideo.playsInline = true;
  galleryVideo.style.display = 'none';
  galleryWrap.appendChild(galleryVideo);

  // Iframe for external videos (hidden by default)
  var galleryIframe = document.createElement('iframe');
  galleryIframe.className = 'hm-gallery-full hm-gallery-full--iframe';
  galleryIframe.setAttribute('allowfullscreen', '');
  galleryIframe.setAttribute('allow', 'autoplay; encrypted-media');
  galleryIframe.frameBorder = '0';
  galleryIframe.style.display = 'none';
  galleryWrap.appendChild(galleryIframe);

  // Arrow buttons
  var prevBtn = document.createElement('button');
  prevBtn.className = 'hm-gallery-arrow hm-gallery-arrow--prev';
  prevBtn.type = 'button';
  prevBtn.innerHTML = '\u2039';
  prevBtn.title = 'Previous';
  galleryWrap.appendChild(prevBtn);

  var nextBtn = document.createElement('button');
  nextBtn.className = 'hm-gallery-arrow hm-gallery-arrow--next';
  nextBtn.type = 'button';
  nextBtn.innerHTML = '\u203A';
  nextBtn.title = 'Next';
  galleryWrap.appendChild(nextBtn);

  // Insert wrap before gallery in DOM
  gallery.parentNode.insertBefore(galleryWrap, gallery);

  // X close button
  var closeBtn = document.createElement('button');
  closeBtn.className = 'hm-gallery-close';
  closeBtn.type = 'button';
  closeBtn.innerHTML = '\u2715';
  closeBtn.title = 'Close gallery';
  galleryWrap.appendChild(closeBtn);

  var thumbs = strip.querySelectorAll('.hm-gallery-thumb');
  // Preload images only
  thumbs.forEach(function(t) {
    if (t.dataset.galleryType === 'image') {
      var img = new Image(); img.src = t.dataset.gallerySrc;
    }
  });

  var backBtn = document.createElement('button');
  backBtn.className = 'hm-gallery-back';
  backBtn.type = 'button';
  backBtn.textContent = '\u2190 Back';
  gallery.appendChild(backBtn);   // inside the rail, under the thumbs, like the star map gallery

  var currentIndex = -1;

  function hideAllMedia() {
    galleryImg.style.display = 'none';
    galleryVideo.style.display = 'none';
    galleryVideo.pause();
    galleryVideo.innerHTML = '';
    galleryIframe.style.display = 'none';
    galleryIframe.src = '';
  }

  function showMedia(thumb) {
    hideAllMedia();
    var type = thumb.dataset.galleryType;

    if (type === 'image') {
      galleryImg.src = thumb.dataset.gallerySrc;
      galleryImg.style.display = '';
    } else if (type === 'video') {
      try {
        var sources = JSON.parse(thumb.dataset.galleryVideoSources);
        sources.forEach(function(s) {
          var source = document.createElement('source');
          source.src = s.url;
          source.type = s.mime;
          galleryVideo.appendChild(source);
        });
      } catch(e) {}
      galleryVideo.style.display = '';
      galleryVideo.load();
    } else if (type === 'external_video') {
      galleryIframe.src = thumb.dataset.galleryEmbedUrl;
      galleryIframe.style.display = '';
    }
  }

  function goTo(index) {
    currentIndex = ((index % thumbs.length) + thumbs.length) % thumbs.length;
    showMedia(thumbs[currentIndex]);
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    thumbs[currentIndex].classList.add('active');
    thumbs[currentIndex].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  function openGallery(index) {
    appMain.classList.add('hm-gallery-viewing');
    gallery.classList.add('hm-gallery-open');
    backBtn.classList.add('visible');
    goTo(index);
  }

  function closeGallery() {
    hideAllMedia();
    appMain.classList.remove('hm-gallery-viewing');
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    backBtn.classList.remove('visible');
    currentIndex = -1;
    gallery.classList.remove('hm-gallery-open');
  }

  // Tablet/mobile bottom-left toggle button — mirrors starmap-gallery.js's
  // .sm-gallery-mobile-toggle pattern so the gallery affordance looks
  // identical across hor-moon and starmap/locationmap at ≤1199px. The
  // button gets appended to .h-app__main (the customizer's print area)
  // and toggles .hm-gallery--mobile-open on the gallery panel, which the
  // CSS @media block translates between off-screen and on-screen.
  var appMain = document.querySelector('.h-app__main');
  var mobileToggle = document.createElement('button');
  mobileToggle.type = 'button';
  mobileToggle.className = 'hm-gallery-mobile-toggle';
  mobileToggle.setAttribute('aria-label', 'Toggle product gallery');
  mobileToggle.setAttribute('aria-expanded', 'false');
  mobileToggle.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>';
  if (appMain) appMain.appendChild(mobileToggle);

  function openMobileGallery() {
    gallery.classList.add('hm-gallery--mobile-open');
    mobileToggle.classList.add('hm-gallery-mobile-toggle--open');
    mobileToggle.setAttribute('aria-expanded', 'true');
  }
  function closeMobileGallery() {
    gallery.classList.remove('hm-gallery--mobile-open');
    mobileToggle.classList.remove('hm-gallery-mobile-toggle--open');
    mobileToggle.setAttribute('aria-expanded', 'false');
  }
  mobileToggle.addEventListener('click', function(e) {
    e.stopPropagation();
    if (gallery.classList.contains('hm-gallery--mobile-open')) closeMobileGallery();
    else openMobileGallery();
  });
  // Click outside (anywhere except the gallery + toggle) closes the panel.
  document.addEventListener('click', function(e) {
    if (!gallery.classList.contains('hm-gallery--mobile-open')) return;
    if (gallery.contains(e.target) || mobileToggle.contains(e.target)) return;
    closeMobileGallery();
  });
  // Selecting a thumb on tablet/mobile auto-closes the panel after the
  // full-size opens. Breakpoint matches the CSS @media gate (1199).
  strip.addEventListener('click', function(e) {
    if (e.target.closest('.hm-gallery-thumb') && window.innerWidth <= 1199) {
      setTimeout(closeMobileGallery, 50);
    }
  });

  // Mobile close button
  mobileCloseBtn.addEventListener('click', function() {
    if (currentIndex >= 0) {
      closeGallery();
    } else {
      gallery.classList.remove('hm-gallery-open');
    }
  });

  // Arrow clicks
  prevBtn.addEventListener('click', function() { if (currentIndex >= 0) goTo(currentIndex - 1); });
  nextBtn.addEventListener('click', function() { if (currentIndex >= 0) goTo(currentIndex + 1); });

  // Thumbnail click
  strip.addEventListener('click', function(e) {
    var thumb = e.target.closest('.hm-gallery-thumb');
    if (!thumb) return;
    var idx = Array.prototype.indexOf.call(thumbs, thumb);
    openGallery(idx);
  });

  // Back button (desktop)
  backBtn.addEventListener('click', closeGallery);

  // X close button
  closeBtn.addEventListener('click', closeGallery);

  // Keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (currentIndex < 0) return;
    if (e.key === 'ArrowLeft') { goTo(currentIndex - 1); e.preventDefault(); }
    else if (e.key === 'ArrowRight') { goTo(currentIndex + 1); e.preventDefault(); }
    else if (e.key === 'Escape') { closeGallery(); e.preventDefault(); }
  });

  // Drag-to-scroll on desktop
  (function() {
    var isDown = false, startY, scrollTop, dragged = false;
    strip.style.cursor = 'grab';
    strip.addEventListener('mousedown', function(e) {
      isDown = true; dragged = false;
      strip.style.cursor = 'grabbing';
      startY = e.pageY - strip.offsetTop;
      scrollTop = strip.scrollTop;
      e.preventDefault();
    });
    strip.addEventListener('mouseleave', function() { isDown = false; strip.style.cursor = 'grab'; });
    strip.addEventListener('mouseup', function(e) {
      isDown = false; strip.style.cursor = 'grab';
      if (dragged) { e.stopPropagation(); dragged = false; }
    });
    strip.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      var y = e.pageY - strip.offsetTop;
      var diff = Math.abs(y - startY + scrollTop - strip.scrollTop);
      if (diff > 5) dragged = true;
      e.preventDefault();
      strip.scrollTop = scrollTop - (y - startY) * 1.5;
    });
    strip.addEventListener('click', function(e) {
      if (dragged) { e.stopImmediatePropagation(); dragged = false; }
    }, true);
  })();

  // Mobile swipe on gallery viewer
  (function() {
    var touchStartX = 0, touchStartY = 0, swiping = false;
    galleryWrap.addEventListener('touchstart', function(e) {
      if (currentIndex < 0) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      swiping = true;
    }, { passive: true });

    galleryWrap.addEventListener('touchend', function(e) {
      if (!swiping || currentIndex < 0) return;
      swiping = false;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0) goTo(currentIndex + 1);
        else goTo(currentIndex - 1);
      }
    }, { passive: true });
  })();

  // Left/right tap navigation on gallery image
  galleryImg.addEventListener('click', function(e) {
    if (currentIndex < 0) return;
    var rect = galleryImg.getBoundingClientRect();
    var clickX = e.clientX - rect.left;
    if (clickX < rect.width / 2) {
      goTo(currentIndex - 1);
    } else {
      goTo(currentIndex + 1);
    }
  });
})();


/* Arrow placement: hug the displayed image (14px off each edge) so the pair reads symmetric whatever the
   image shape or window size. The CSS positions are the fallback until the image has a size. */
(function () {
  var GAP = 14, SIZE = 36;
  function place() {
    var wrap = document.querySelector('.hm-gallery-full-wrap');
    var img = document.querySelector('.hm-gallery-full');
    var prev = document.querySelector('.hm-gallery-arrow--prev');
    var next = document.querySelector('.hm-gallery-arrow--next');
    if (!wrap || !img || !prev || !next || window.innerWidth < 750) return;
    var w = wrap.getBoundingClientRect(), r = img.getBoundingClientRect();
    if (!r.width || getComputedStyle(img).display === 'none') { prev.style.left = ''; next.style.left = ''; next.style.right = ''; return; }
    var left = r.left - w.left - GAP - SIZE;
    var minLeft = 100;                      // never under the thumbnail rail
    prev.style.left = Math.max(minLeft, left) + 'px';
    next.style.right = 'auto';
    next.style.left = (r.right - w.left + GAP) + 'px';
  }
  var img = document.querySelector('.hm-gallery-full');
  if (img) {
    img.addEventListener('load', function () { setTimeout(place, 30); });
    if (window.ResizeObserver) new ResizeObserver(function () { place(); }).observe(img);
  }
  window.addEventListener('resize', place);
  document.addEventListener('click', function () { setTimeout(place, 60); }, true);
})();
